import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { fetchLocations } from '../api'

import { locationsListActions } from './actions';
import { getLocationsListsById } from './selectors';

export function* loadLocationsList({payload}) {

  const { id, sessionId } = payload;

  const locationsList = yield select(getLocationsListsById, id);
  if ( id && !locationsList) {
    yield call(fetchLocations, id, { provinceId: id, sessionId});
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadLocations() {
  yield takeLatest(locationsListActions.LOAD_LOCATIONS, loadLocationsList);
}

//=====================================
//  ROOT
//-------------------------------------

export const locationsListSagas = [
  fork(watchLoadLocations),
];
